import { createSelector } from 'reselect';
import type { DefaultRootState } from 'react-redux';

const libraryIds = createSelector(
  (state: DefaultRootState) => state.spaceList.data,
  (data) => Object.values(data || {}).map((item) => item.libraryId),
);

export default libraryIds;
